// src/App.js
import React, { useState, useEffect } from 'react';
import mobileBg from './assets/mobile-bg.jpg';    // your image in src/assets
import Header    from './maincomponents/Header';
import Home      from './maincomponents/Home';
import About     from './maincomponents/About';
import Services  from './maincomponents/Services';
import TreasuCRE from './maincomponents/TreasuCRE';
import Footer    from './maincomponents/Footer';
import './index.css';                            // Tailwind + your custom CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const App = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [isMobile, setIsMobile]         = useState(window.innerWidth < 640);

  // Highlight current section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'services', 'treasuCRE'];
      const mid      = window.scrollY + window.innerHeight / 2;
      sections.forEach((sec) => {
        const el = document.getElementById(sec);
        if (
          el &&
          el.offsetTop <= mid &&
          el.offsetTop + el.offsetHeight > mid
        ) {
          setActiveSection(sec);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Update mobile flag on resize
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Inline style only on mobile
  const mobileStyle = isMobile
    ? {
        backgroundImage:    `url(${mobileBg})`,
        backgroundSize:     'cover',
        backgroundPosition: 'center',
      }
    : {};

  const scrollToSection = (sec) => {
    const el = document.getElementById(sec);
    if (el) window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
  };

  return (
    <div
      className="font-sans min-h-screen text-center bg-lavender"
      style={mobileStyle}    // <-- background only via JS import
    >
      <Header
        activeSection={activeSection}
        scrollToSection={scrollToSection}
      />
      <Home />
      <TreasuCRE />
      <Services />
      <About />
      <Footer />
    </div>
  );
};

export default App;
